import React, { useState, useEffect } from 'react';
import _, { lastIndexOf } from 'lodash';
import 'draft-js/dist/Draft.css';

import {
  Stack,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Tooltip
} from '@mui/material';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import useUtils from '../../../hook/useUtils';
import { generateUniqueKey } from '../../../utils/date';

import { SearchInputGreenMain } from '../../customComponent/form';
import { handleColorSystem } from '../../customComponent/colorSystem';
import { SearchIcon, ErrorOutlineIcon, DeleteOutlineOutlinedIcon } from '../../../constants/images';
import theme from '../../../theme';


const fieldsBlockHeightS = '395px';

const checkFieldIsSelected = (currentData, originalData) => {
  return _.findIndex(currentData, ['expression', originalData]) > -1 ? true : false;
}

const LineFieldsAllMetric = (props) => {
  const {
    handleModalDetail,
    changeDefinedFields,
    currentSheetName,
    allDisplayFields,
    currentSheetSelectFields,
    setCurrentSheetSelectFields,
    selectedGeneralFields,
    setSelectedGeneralFields,
    selectedCustomFields,
    campaignGoalsList,
    searchKeyword,
    setSearchKeyword,
    handleDeleteFields
  } = props;

  const { currentActiveData, setCurrentActiveData } = useGlobalStatus();
  const [filterOptionFields, setFilterOptionFields] = useState([]);
  const [transformExpressToTw] = useUtils();
  const [showButton, setShowButton] = useState(false);
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem('LINE');

  useEffect(() => {
    let fields;

    if (searchKeyword) {
      fields = allDisplayFields.map((el) => {
        const filteredChild = el.child.filter((elem) =>
          elem.name.toLowerCase().includes(searchKeyword.toLowerCase())
        );
        return { ...el, child: filteredChild };
      });

    } else {
      fields = allDisplayFields;
    }

    setFilterOptionFields(fields);
  }, [searchKeyword, allDisplayFields]);

  //滑入顯示自訂欄名稱
  const handleTitle = (field) => {
    const allFields = _.concat(selectedGeneralFields, selectedCustomFields);

    const transformExpression = transformExpressToTw(field.expression, allFields);
    const format = field.format === 'PERCENT' ? '百分比' : field.format === 'DEFAULT' ? '數字' : '$';
    return `${transformExpression} (${format})`;
  }

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
  };

  const handleshowButton = (field, method) => {
    if (field.type === 'CUSTOM' && !field.cid) {
      method === 'enter' ? setShowButton(true) : setShowButton(false);
    }
  }

  return (
    <Box
      sx={{
        flex: 1.6,
        hight: '100%',
        borderRight: `1px solid ${theme.palette.grey.w200}`
      }}
    >
      <Box sx={{ padding: '20px 16px 4px' }} >
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            paddingBottom: '4px',
            borderBottom: `1px solid ${theme.palette.grey.w200}`
          }}
        >
          所有欄位
          {
            campaignGoalsList.length !== 0 &&
            <Typography
              variant="caption"
              sx={{
                cursor: 'pointer',
                color: mainColor
              }}
              onClick={() => handleModalDetail('create_custom_metric')}
            >
              建立自訂衡量指標
            </Typography>
          }
        </Typography>
        {
          currentSheetName === "" ? "" :
            <SearchInputGreenMain
              id="search"
              placeholder="搜尋欄位名稱"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              sx={{
                width: "100%",
                marginTop: "10px",
              }}
              value={searchKeyword}
              onChange={handleSearchInput}
            />
        }
      </Box>
      {
        <Box
          pt={1}
          sx={{
            height: fieldsBlockHeightS,
            overflow: 'auto',
            paddingLeft: '16px',
            paddingRight: '8px',
          }}
        >
          {
            currentSheetName === "" && !campaignGoalsList.length ?
              (<Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: theme.palette.grey.w300,
                }}
              >
                <ErrorOutlineIcon sx={{ right: '4px' }} />
                無資料
              </Box>) : ""
          }
          {
            currentSheetName === "" && campaignGoalsList.length ?
              (<Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: theme.palette.grey.w300,
                }}
              >
                <ErrorOutlineIcon sx={{ right: '4px' }} />
                請先點選廣告目標
              </Box>) : ""
          }
          {
            filterOptionFields.map((el, index) => {
              const mainTitle = el.name === '自訂轉換欄' ? el.category : null;
              return (
                <Box key={`${el.category}_${index}`}>
                  {
                    currentSheetName === "" ? "" :
                      el.child.length > 0 &&
                      <>
                        <Typography
                          sx={{
                            marginBottom: '8px',
                            padding: '4px 0 4px 8px',
                            backgroundColor: theme.palette.grey.w100,
                            borderRadius: '2px'
                          }}
                          title={mainTitle}
                        >
                          {el.name}
                        </Typography>

                        <Box pl={0.5} pb={1}>
                          {
                            el.child.map((item, index) => {
                              const title = el.category === 'custom' ? handleTitle(item) : null;

                              return (
                                <Stack
                                  key={`${item.expression}_${index}`}
                                  variant='between-center'
                                  onMouseEnter={() => handleshowButton(item, 'enter')}
                                  onMouseLeave={() => handleshowButton(item, 'leave')}
                                >
                                  <>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          size="small"
                                          name={item.expression}
                                          sx={{ paddingTop: 0, paddingBottom: '2px' }}
                                          checked={checkFieldIsSelected(currentSheetSelectFields, item.expression)}
                                          onChange={(e) => changeDefinedFields(e, item)}
                                          color={colorSystem}
                                        />
                                      }
                                      label={item.name}
                                      title={title}
                                      sx={{ display: 'block', marginBottom: '8px' }}
                                    />
                                    {
                                      showButton && item.type === 'CUSTOM' && !item.cid &&
                                      <Tooltip title="刪除指標（從所有頁籤中刪除）">
                                        <DeleteOutlineOutlinedIcon
                                          variant="dark"
                                          sx={{
                                            marginRight: '8px',
                                            marginBottom: '8px',
                                            '&:hover': {
                                              color: mainColor,
                                              cursor: 'pointer'
                                            }
                                          }}
                                          onClick={(e) => handleDeleteFields(e, item, 'deleteField')}
                                        />
                                      </Tooltip>
                                    }
                                  </>
                                </Stack>
                              )
                            })
                          }
                        </Box>
                      </>
                  }
                </Box>
              )
            })
          }
        </Box>
      }
    </Box>
  )
}

export default LineFieldsAllMetric;